import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { useNavigate, useLocation, Link } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { IconButton, InputAdornment } from "@mui/material";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import AppButton from "../../common/AppButton";
import EyeIcon from "../../IconComp/eye";
import EyeVisibleIcon from "../../IconComp/eyeVisible";
interface IProps {
  handlePasswordSubmit: any;
  handleInputChangeResetPass: any;
  handleTogglePasswordVisibility: any;
  handleToggleConfirmPasswordVisibility: any;
  resetPassValue: any;
  showPassword: any;
  showConfirmPassword: any;
  errors: any;
}
const ResetPassword = ({
  handlePasswordSubmit,
  handleInputChangeResetPass,
  handleTogglePasswordVisibility,
  handleToggleConfirmPasswordVisibility,
  resetPassValue,
  showPassword,
  showConfirmPassword,
  errors,
}: IProps) => {
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const { isLoading, isLoginError, loginMessage } = useAppSelector(
    (state: any) => state?.auth
  );

  const isMobile = useMediaQuery("(max-width: 1022px)");
  return (
    <>
      <Box
        sx={{
          paddingLeft: isMobile ? "0px" : "30px",
          paddingRight: isMobile ? "0px" : "30px",
        }}
      >
        <Box sx={{ textAlign: "center", fontSize: "18px", fontWeight: 500 }}>
          Reset Password?
        </Box>
        <Box
          sx={{
            textAlign: "center",
            fontSize: "12px",
            fontWeight: 400,
            mb: 4.5,
            mt: 2,
          }}
        >
          Please type something you'll remember
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              name="password"
              label="New Password"
              type={showPassword ? "text" : "password"}
              value={resetPassValue.password}
              onChange={handleInputChangeResetPass}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleTogglePasswordVisibility}
                      edge="end"
                    >
                      {showPassword ? <EyeVisibleIcon /> : <EyeIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiInputBase-root": {
                  height: "40px", // Set the total height of the input field
                  padding: "0", // Remove default padding
                  display: "flex",
                  alignItems: "center", // Center the input content
                  justifyContent: "center",
                  paddingRight: "15px",
                },
                "& .MuiFormLabel-root": {
                  top: "-5px", // Adjust label positioning if necessary
                },
                "& .MuiInputBase-input": {
                  padding: "0 10px", // Add inner padding for input
                  height: "100%", // Fill the container's height
                  boxSizing: "border-box",
                },
              }}
            />
            {errors.password && (
              <p style={{ color: "red", fontSize: "12px" }}>
                {errors.password}
              </p>
            )}
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="confirmPassword"
              label="Confirm new Password"
              type={showConfirmPassword ? "text" : "password"}
              value={resetPassValue.confirmPassword}
              onChange={handleInputChangeResetPass}
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleToggleConfirmPasswordVisibility}
                      edge="end"
                    >
                      {showConfirmPassword ? <EyeVisibleIcon /> : <EyeIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiInputBase-root": {
                  height: "40px", // Set the total height of the input field
                  padding: "0", // Remove default padding
                  display: "flex",
                  alignItems: "center", // Center the input content
                  justifyContent: "center",
                  paddingRight: "15px",
                },
                "& .MuiFormLabel-root": {
                  top: "-5px", // Adjust label positioning if necessary
                },
                "& .MuiInputBase-input": {
                  padding: "0 10px", // Add inner padding for input
                  height: "100%", // Fill the container's height
                  boxSizing: "border-box",
                },
              }}
            />
            {errors.confirmPassword && (
              <p style={{ color: "red", fontSize: "12px" }}>
                {errors.confirmPassword}
              </p>
            )}
          </Grid>
        </Grid>

        <AppButton
          title="Submit"
          onClick={handlePasswordSubmit}
          fullWidth
          variant="contained"
          sx={{ mt: 4, mb: 2 }}
        />
      </Box>
    </>
  );
};

export default ResetPassword;
